import { createSlice } from "@reduxjs/toolkit";
import VwHastaislemlistDTO from "src/models/GenelTanimlar/VwHastaIslemDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { ApiResponse } from "src/services/core";

export type HastaIslemListResponse = ApiResponse<Array<VwHastaislemlistDTO>> & {
    isFetching?: boolean;
    isLoading?: boolean;
};

interface ITestYinele {
    open: boolean;
    data: HastaIslemListResponse;
}

export const TestYineleSlice = createSlice<ITestYinele, MapReducerPayloads<ITestYinele, {
    setOpen: boolean;
    setData: HastaIslemListResponse;
}>>({
    name: "testYinele",
    initialState: {
        open: false,
        data: { data: [], isFetching: false, isLoading: true, },
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
    },
});